//import { default as TemplatesFunc } from '../directives/cached-templates/templates';

import { default as FixHeaderPanel } from '../directives/fix-header-panel/fix-header-panel';
import { default as BurgerMenu } from '../directives/flyout-menu/burger-menu';
import { default as MiniSideBar } from '../directives/flyout-menu/mini-side-bar';
import { default as SideBar } from '../directives/flyout-menu/side-bar';

import { default as AuthModal } from '../directives/modals/auth-modal';
import { default as AuthModalBody } from '../directives/modals/auth-modal-body';
import { default as AuthModalHeader } from '../directives/modals/auth-modal-header';

//import { default as LoadingDocument } from '../directives/modals/loading-document';
import { default as PDFViewer } from '../directives/modals/pdf-viewer';

import { default as Scrollable } from '../directives/scrollable/scrollable';
import { default as ScrollableCtrl } from '../directives/scrollable/scrollable-ctrl';
import { default as ScrollableMenu } from '../directives/scrollable/scrollable-menu';
import { default as ScrollableDocuments } from '../directives/scrollable/scrollable-documents';

import { default as CompareWith } from '../directives/validation/compare-with';
import { default as Error } from '../directives/validation/error';
import { default as Validation } from '../directives/validation/validation';
import { default as MultiMaxLength } from '../directives/validation/multi-max-length';
import { default as ValidationSummary } from '../directives/validation/validation-summary';

import { default as AuthNav } from '../directives/auth-nav';
import { default as NgHtmlCompile } from '../directives/ng-html-compile';
import { default as NotificationModal } from '../directives/notification-modal';
import { default as UserMenu } from '../directives/user-menu';

import { default as DocumentsSelector } from '../directives/modals/documents-selector';
import { default as DocumentsScroller } from '../directives/scrollable/documents/documents-scroller';

import { Back, Front, FlipCard } from '../directives/flip-card';

import { BuildingsTopNav, BuildingsSideNav, MobileTopBar } from '../directives/nav-bar';
import { default as Navigation } from '../directives/nav-bar/main-site/navigation';
import { default as MainBusyIndicator } from '../directives/loader/main-busy-indicator';
import {
	default as PaymentApprovalsMobile,
	PaymentStatusPill,
	PaymentHaptic,
	PaymentAutogrow
} from '../components/payments/mobile/payment-approvals-mobile';

export default angular
	.module('pretor.online.directives', [])
	.directive('back', Back)
	.directive('error', Error)
	.directive('front', Front)
	.directive('authNav', AuthNav)
	.directive('sideBar', SideBar)
	.directive('userMenu', UserMenu)
	.directive('flipCard', FlipCard)
	.directive('pdfViewer', PDFViewer)
	.directive('authModal', AuthModal)
	.directive('scrollable', Scrollable)
	.directive('validation', Validation)
	.directive('burgerMenu', BurgerMenu)
	.directive('navigation', Navigation)
	.directive('compareWith', CompareWith)
	.directive('miniSideBar', MiniSideBar)
	.directive('mobileTopBar', MobileTopBar)
	.directive('mainBusyIndicator', MainBusyIndicator)
	.directive('paymentApprovalsMobile', PaymentApprovalsMobile)
	.directive('paymentStatusPill', PaymentStatusPill)
	.directive('paHaptic', PaymentHaptic)
	.directive('paAutogrow', PaymentAutogrow)
	.directive('authModalBody', AuthModalBody)
	.directive('ngHtmlCompile', NgHtmlCompile)
	.directive('scrollableCtrl', ScrollableCtrl)
	.directive('multiMaxLength', MultiMaxLength)
	.directive('scrollableMenu', ScrollableMenu)
	.directive('fixHeaderPanel', FixHeaderPanel)
	.directive('authModalHeader', AuthModalHeader)
	.directive('buildingsTopNav', BuildingsTopNav)
	.directive('buildingsSideNav', BuildingsSideNav)
	.directive('validationSummary', ValidationSummary)
	.directive('documentsSelector', DocumentsSelector)
	.directive('notificationModal', NotificationModal)
	.directive('documentsScroller', DocumentsScroller)
	.directive('scrollableDocuments', ScrollableDocuments);

require('../directives/cached-templates/templates');
